import { useConfiguration } from './useConfiguration';

export function useCameraLimitReached(): boolean {
    const { configuration } = useConfiguration();
    return (
        configuration !== undefined &&
        configuration.currentCameras >= configuration.maxCameras.value
    );
}
